import { getTrackingId } from './storageUtils';

let postHogInstance: any;
let eventQueue: Array<{ eventCode: string; properties: object }> = [];

export function getPostHogInstance() {
  return postHogInstance;
}

export function setPostHogInstance(instance: any) {
  postHogInstance = instance;
}

export function addEventToQueue(eventCode: string, properties: object) {
  eventQueue.push({ eventCode, properties });
}

export async function initializePostHog() {
  let posthog = getPostHogInstance();

  if (!posthog) {
    const posthogModule = await import('posthog-js');
    posthog = posthogModule.default;

    posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY ?? '', {
      api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    });
    posthog.isIdentificationDone = false;
    setPostHogInstance(posthog);
    startPostHogIdentification();
  }
  return;
}

export function startPostHogIdentification() {
  const intervalId = setInterval(() => {
    const trackingId = getTrackingId();

    if (trackingId && getPostHogInstance()) {
      getPostHogInstance().identify(trackingId);
      getPostHogInstance().isIdentificationDone = true;
      while (eventQueue.length > 0) {
        const { eventCode, properties } = eventQueue.shift()!;
        getPostHogInstance().capture(eventCode, properties);
      }
      clearInterval(intervalId);
    }
  }, 100);
}
